import React from 'react';
import { Lock } from "lucide-react";
import { useNavigate } from 'react-router-dom';
import { Button } from "../tailwind/button";
import { waBtn } from "../../pages/whatsapp/utils/whatsappUiTokens";

const SubscriptionNotice = ({ message = "You don't have an active plan" }) => {
  const navigate = useNavigate();

  return (
    <div className="mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
      <div className="flex items-center gap-3">
        <Lock className="h-6 w-6 text-red-600 dark:text-red-400" />
        <div className="flex-1">
          <h3 className="font-semibold text-red-800 dark:text-red-200">Subscription Required</h3>
          <p className="text-sm text-red-700 dark:text-red-300">
            {message}
          </p>
        </div>
        <Button
          onClick={() => navigate('/whatsapp/billing')}
          className={waBtn.primary}
        >
          Upgrade Plan
        </Button>
      </div>
    </div>
  );
};

export default SubscriptionNotice;
